"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _AvatarTagList = _interopRequireDefault(require("crm_ui/engagementAssociations/components/AvatarTagList"));

var _generalStore = require("general-store");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIFloatingFormControl = _interopRequireDefault(require("UIComponents/form/UIFloatingFormControl"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _makeEngagementAssociationSelect = _interopRequireDefault(require("crm_ui/engagementAssociations/components/makeEngagementAssociationSelect"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _BETPortalObjectsAssociationOptionsDependency = _interopRequireDefault(require("crm_ui/BET/engagementAssociations/dependencies/BETPortalObjectsAssociationOptionsDependency"));

var _BETServiceObjectsAssociationOptionsDependency = _interopRequireDefault(require("crm_ui/BET/engagementAssociations/dependencies/BETServiceObjectsAssociationOptionsDependency"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _BETEngagementAssociationsSelectsUtils = require("crm_ui/engagementAssociations/components/BETEngagementAssociationsSelectsUtils");

var _BETAssociatedPortalObjectsDependency = _interopRequireDefault(require("crm_ui/BET/dependencies/BETAssociatedPortalObjectsDependency"));

var _BETAssociatedServiceObjectsDependency = _interopRequireDefault(require("crm_ui/BET/dependencies/BETAssociatedServiceObjectsDependency"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var BETPortalObjectsSelect = (0, _makeEngagementAssociationSelect.default)({
  name: 'BETPortalObjectsSelect',
  OptionsDependency: _BETPortalObjectsAssociationOptionsDependency.default,
  associatedObjectType: 'portalObject'
});
var BETServiceObjectsSelect = (0, _makeEngagementAssociationSelect.default)({
  name: 'BETServiceObjectsSelect',
  OptionsDependency: _BETServiceObjectsAssociationOptionsDependency.default,
  associatedObjectType: 'serviceObject'
});
var dependencyPropTypes = {
  engagement: _propTypes.default.instanceOf(_EngagementRecord.default),
  BETAssociatedPortalObjects: _reactImmutableProptypes.default.list,
  BETAssociatedServiceObjects: _reactImmutableProptypes.default.list
};
var propTypes = (0, _extends2.default)({}, dependencyPropTypes, {
  BETPortalAssociations: _reactImmutableProptypes.default.list,
  BETServiceAssociations: _reactImmutableProptypes.default.list,
  subject: _SubjectType.default.isRequired,
  onAddBETAssociation: _propTypes.default.func,
  onRemoveBETAssociation: _propTypes.default.func
});
var defaultProps = {
  inTimeline: false,
  BETPortalAssociations: (0, _immutable.List)(),
  BETServiceAssociations: (0, _immutable.List)(),
  onAddBETAssociation: _emptyFunction.default,
  onRemoveBETAssociation: _emptyFunction.default
};

var BETEngagementAssociationsSelects =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BETEngagementAssociationsSelects, _PureComponent);
  (0, _createClass2.default)(BETEngagementAssociationsSelects, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var newState = state;
      var BETQueryAssociationsSet = state.BETQueryAssociationsSet;
      var BETPortalAssociationsForQuery = props.BETPortalAssociationsForQuery,
          BETServiceAssociationsForQuery = props.BETServiceAssociationsForQuery,
          inTimeline = props.inTimeline,
          BETInitialQueryIds = props.BETInitialQueryIds,
          engagementType = props.engagementType;

      if (!inTimeline && BETInitialQueryIds) {
        if (!BETQueryAssociationsSet.get('serviceObjectIds').has(engagementType) && _ScopesContainer.default.isScoped('bet-deliverable-service-association-access') && BETServiceAssociationsForQuery && BETInitialQueryIds.get('serviceObjectIds')) {
          (0, _BETEngagementAssociationsSelectsUtils.setBETQueryServiceObjects)(props);
          newState = (0, _extends2.default)({}, newState, {
            BETQueryAssociationsSet: BETQueryAssociationsSet.setIn(['serviceObjectIds', engagementType, true])
          });
        }

        if (!BETQueryAssociationsSet.get('portalObjectIds').has(engagementType) && _ScopesContainer.default.isScoped('bet-portal-association-access') && BETPortalAssociationsForQuery && BETInitialQueryIds.get('portalObjectIds')) {
          (0, _BETEngagementAssociationsSelectsUtils.setBETQueryPortalObjects)(props);
          newState = (0, _extends2.default)({}, newState, {
            BETQueryAssociationsSet: BETQueryAssociationsSet.setIn(['portalObjectIds', engagementType, true])
          });
        }
      }

      return newState;
    }
  }]);

  function BETEngagementAssociationsSelects(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BETEngagementAssociationsSelects);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BETEngagementAssociationsSelects).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      values: [],
      BETQueryAssociationsSet: (0, _immutable.Map)({
        portalObjectIds: (0, _immutable.Map)(),
        serviceObjectIds: (0, _immutable.Map)()
      })
    };
    return _this;
  }

  (0, _createClass2.default)(BETEngagementAssociationsSelects, [{
    key: "getBETAssociationTagValues",
    value: function getBETAssociationTagValues(associationType) {
      return this.props[associationType].map(function (assoc) {
        return {
          value: assoc.get('label'),
          tagOptions: {
            textOnly: true
          }
        };
      });
    }
  }, {
    key: "handleRemoveBETTag",
    value: function handleRemoveBETTag(associationType) {
      var _this2 = this;

      return function (value) {
        var associationToRemove = _this2.props[associationType].find(function (association) {
          return value === association.get('label');
        });

        _this2.props.onRemoveBETAssociation(associationType)(associationToRemove);
      };
    }
  }, {
    key: "renderContents",
    value: function renderContents() {
      return _react.default.createElement("div", null, _react.default.createElement(_UIFlex.default, {
        wrap: "wrap"
      }, this.renderTagList()), this.renderSelects());
    }
  }, {
    key: "renderSelects",
    value: function renderSelects() {
      var _this$props = this.props,
          subject = _this$props.subject,
          BETPortalAssociations = _this$props.BETPortalAssociations,
          BETServiceAssociations = _this$props.BETServiceAssociations,
          onAddBETAssociation = _this$props.onAddBETAssociation,
          onRemoveBETAssociation = _this$props.onRemoveBETAssociation;
      var BETServiceValues = BETServiceAssociations.map(function (association) {
        return association.get('objectId');
      }).toArray();
      var BETPortalValues = BETPortalAssociations.map(function (association) {
        return association.get('objectId');
      }).toArray();
      var objectType = (0, _ImmutableModel.getObjectType)(subject);
      return _react.default.createElement(_UIList.default, {
        inline: true
      }, _ScopesContainer.default.isScoped('bet-deliverable-service-association-access') && objectType === _ObjectTypes.CONTACT && _react.default.createElement(BETServiceObjectsSelect, {
        objectType: objectType,
        subjectId: "" + (0, _ImmutableModel.getId)(subject),
        subject: subject,
        handleSelect: onAddBETAssociation('BETServiceAssociations'),
        handleRemove: onRemoveBETAssociation('BETServiceAssociations'),
        placeholderText: _I18n.default.text('bet.associations.addServiceObject'),
        value: BETServiceValues,
        isBET: true
      }), _ScopesContainer.default.isScoped('bet-portal-association-access') && objectType === _ObjectTypes.CONTACT && _react.default.createElement(BETPortalObjectsSelect, {
        objectType: objectType,
        subjectId: "" + (0, _ImmutableModel.getId)(subject),
        subject: subject,
        handleSelect: onAddBETAssociation('BETPortalAssociations'),
        handleRemove: onRemoveBETAssociation('BETPortalAssociations'),
        placeholderText: _I18n.default.text('bet.associations.addPortal'),
        value: BETPortalValues,
        isBET: true
      }));
    }
  }, {
    key: "renderTagList",
    value: function renderTagList() {
      return _react.default.createElement("div", {
        className: "width-100"
      }, _react.default.createElement(_AvatarTagList.default, {
        "data-selenium-test-bet": "associated-service-tags",
        tagLinkTarget: "_blank",
        valuesAreObjectTypes: false,
        values: this.getBETAssociationTagValues('BETServiceAssociations'),
        handleRemove: this.handleRemoveBETTag('BETServiceAssociations')
      }), _react.default.createElement(_AvatarTagList.default, {
        "data-selenium-test-bet": "associated-portal-tags",
        tagLinkTarget: "_blank",
        valuesAreObjectTypes: false,
        values: this.getBETAssociationTagValues('BETPortalAssociations'),
        handleRemove: this.handleRemoveBETTag('BETPortalAssociations')
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFloatingFormControl.default, {
        isStatic: true,
        hideEditIcon: true,
        className: "display-block float-form",
        label: _I18n.default.text('associations.associatedWith')
      }, this.renderContents());
    }
  }]);
  return BETEngagementAssociationsSelects;
}(_PureComponent2.default);

BETEngagementAssociationsSelects.propTypes = propTypes;
BETEngagementAssociationsSelects.defaultProps = defaultProps;

var _default = (0, _generalStore.connect)({
  BETInitialQueryIds: _BETEngagementAssociationsSelectsUtils.BETInitialQueryIdsDependency,
  BETPortalAssociationsForQuery: _BETPortalObjectsAssociationOptionsDependency.default,
  BETServiceAssociationsForQuery: _BETServiceObjectsAssociationOptionsDependency.default,
  BETPortalAssociations: _BETAssociatedPortalObjectsDependency.default,
  BETServiceAssociations: _BETAssociatedServiceObjectsDependency.default
})(BETEngagementAssociationsSelects);

exports.default = _default;
module.exports = exports.default;